import { useState as o, useEffect as c } from "react";
const u = (t) => {
  const [r, n] = o(!1), s = new IntersectionObserver(
    ([e]) => {
      n((e == null ? void 0 : e.isIntersecting) ?? !1);
    },
    {
      root: null,
      rootMargin: "0px",
      threshold: 0.3
    }
  );
  return c(() => {
    const e = t.current;
    if (e)
      return s.observe(e), () => {
        s.disconnect();
      };
  }, []), r;
};
export {
  u as useOnScreen
};
